// 导出信息
import {contractApi} from "@/axios";
//导出客户联系人信息
export function exportContacts(data){
    return contractApi({
        url:'/customerContacts/export',
        method:'post',
        data:data,
        responseType: 'blob', // 设置响应类型为 blob
    })
}
//导出课题组信息
export function exportGroup(data){
    return contractApi({
        url:'/researchGroup/export',
        method:'post',
        data:data,
        responseType: 'blob', // 设置响应类型为 blob
    })
}
//导出客户单位信息
export function exportCompany(data){
    return contractApi({
        url:'/customer/export',
        method:'post',
        data:data,
        responseType: 'blob', // 设置响应类型为 blob
    })
}